export default __webpack_public_path__ + "static/media/lighting-foz.bb40a137.png";